import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { $liveqBooking } from '@store';
import { BmiCalculator } from '../../bmiCalculator/BmiCalculator';
import { CheckboxField } from '../../checkbox';
import { InputField } from '../../inputField';
import styles from './index.module.scss';
export const FormQuestion = ({ question, onChange }) => {
    const getContent = (id) => {
        return $liveqBooking.content.find(item => { var _a; return ((_a = item.parents.at(-1)) === null || _a === void 0 ? void 0 : _a.id) === id; });
    };
    const slots = useMemo(() => {
        return $liveqBooking.branches.filter(item => {
            if (item.variation !== 'slot' && item.variation !== 'info') {
                return false;
            }
            return item.parents.at(-1).id === question.id;
        }).sort((a, b) => a.order - b.order);
    }, [$liveqBooking.survey]);
    const bmi = useMemo(() => {
        return slots.find(item => {
            var _a;
            return ((_a = getContent(item.id)) === null || _a === void 0 ? void 0 : _a.sid) === 'bmi';
        });
    }, [$liveqBooking.survey]);
    const [selected, setSelected] = useState([]);
    const [errors, setErrors] = useState({});
    // const heightFeet = data.heightFeet || ''
    // const heightInches = data.heightInches || ''
    // const goalWeight = data.goalWeight || ''
    // const showBmiBlock = data.bmi > 0 && (isBMI || showBMI)
    // if (!fields) return null
    const handleChange = (slot) => {
        return (name, value) => {
            const tmp = selected.filter(item => item.slot_id !== slot.id);
            const newItem = [];
            if (value) {
                newItem.push({ slot_id: slot.id, value: value });
            }
            setSelected([...tmp, ...newItem]);
            onChange([...tmp, ...newItem]);
            // setErrors(prev => ({ ...prev, [name]: '' }))
        };
    };
    const handleCheckboxSelect = (slot) => {
        if (selected.some(el => el.slot_id === slot.id)) {
            setSelected(selected.filter(el => el.slot_id !== slot.id));
            onChange(selected.filter(el => el.slot_id !== slot.id));
            return;
        }
        if (question.subvariation === 'multi_question') {
            const hasSingle = selected.some(el => {
                return slots.some(item => item.id === el.slot_id && item.modifier === 'single');
            });
            if (slot.modifier === 'single' || hasSingle) {
                setSelected([{ slot_id: slot.id }]);
                onChange([{ slot_id: slot.id }]);
                return;
            }
            setSelected([...selected, { slot_id: slot.id }]);
            onChange([...selected, { slot_id: slot.id }]);
        }
        else if (question.subvariation === 'single_question') {
            setSelected([{ slot_id: slot.id }]);
            onChange([{ slot_id: slot.id }]);
            return;
        }
    };
    const validate = () => {
        const newErrors = {};
        // fields.forEach(field => {
        //   const value = data[field.name]
        //
        //   if (field.required && !data[field.name]) {
        //     newErrors[field.name] = `${field.label || field.name} is required`
        //   }
        //
        //   if (field.type === 'email' && value) {
        //     if (!value.includes('@')) {
        //       newErrors[field.name] = 'Email must contain @'
        //     }
        //   }
        // })
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    // useEffect(() => {
    //   if (!!heightFeet || !!goalWeight || !!heightInches) {
    //     handleChange('goalBmi', null)
    //   }
    //
    //   const heightInInches = Number(heightFeet) * 12 + Number(heightInches || 0)
    //   if (heightInInches > 0) {
    //     const bmiValue = (Number(goalWeight) / (heightInInches * heightInInches)) * 703
    //     handleChange('goalBmi', bmiValue.toFixed(2))
    //   }
    // }, [heightFeet, heightInches, goalWeight])
    // useEffect(() => {
    //   if (fields) {
    //     const checkedField = fields.find(f => data[f.name])
    //     if (checkedField) {
    //       setSelected(data[checkedField.name])
    //     }
    //   }
    // }, [fields, data])
    const calculatedBmi = useMemo(() => {
        if (!bmi) {
            return 0;
        }
        const height = selected.find(item => { var _a; return ((_a = getContent(item.slot_id)) === null || _a === void 0 ? void 0 : _a.sid) === 'height'; });
        const weight = selected.find(item => { var _a; return ((_a = getContent(item.slot_id)) === null || _a === void 0 ? void 0 : _a.sid) === 'weight'; });
        if (!height || !weight) {
            return 0;
        }
        const bmiValue = (Number(weight.value) / (height.value * height.value)) * 703;
        return bmiValue.toFixed(2);
    }, [$liveqBooking.survey, selected]);
    const showBmiBlock = bmi && calculatedBmi;
    return (_jsx(_Fragment, { children: slots.map((slot) => {
            var _a, _b, _c, _d, _e, _f;
            return (_jsx("div", { children: slot.subvariation === 'option_slot' ? (_jsx(CheckboxField, { name: slot.name, label: getContent(slot.id).label, checked: selected.some((el) => el.slot_id === slot.id), onChange: () => handleCheckboxSelect(slot) })) : slot.subvariation === 'select' ? (_jsx(_Fragment, {})
                // <SelectField
                //   name={field.name}
                //   value={data[field.name] || ''}
                //   options={field.options || []}
                //   onChange={handleChange}
                //   error={errors[field.name] || ''}
                //   placeholder={field.label}
                // />
                ) : slot.subvariation === 'text_info' ? (_jsx(_Fragment, { children: (((_a = getContent(slot.id)) === null || _a === void 0 ? void 0 : _a.sid) === 'bmi' && calculatedBmi > 0) &&
                        _jsx("div", Object.assign({ className: styles.result }, { children: _jsx("div", Object.assign({ className: styles.bmiValue }, { children: _jsx("span", { children: getContent(slot.id).text.replace("{bmi}", calculatedBmi) }) })) })) })) : (_jsx(_Fragment, { children: ((_c = (_b = getContent(slot.id)) === null || _b === void 0 ? void 0 : _b.tags) === null || _c === void 0 ? void 0 : _c.includes('split:feet-inches')) ?
                        _jsx(_Fragment, { children: _jsx(BmiCalculator, { value: ((_d = selected.find(el => el.slot_id === slot.id)) === null || _d === void 0 ? void 0 : _d.value) || '', errors: undefined, onChange: handleChange(slot) }) }) :
                        _jsx(InputField, { label: (_e = getContent(slot.id)) === null || _e === void 0 ? void 0 : _e.label, type: 'text', name: slot.name, value: ((_f = selected.find((el) => el.slot_id == slot.id)) === null || _f === void 0 ? void 0 : _f.value) || '', onChange: handleChange(slot), error: errors[slot.id] || '' }) })) }, slot.id));
        }) }));
};
